// formatters.ts
export function covertUtcToLocal(utcTimestamp: string): string {
  const newIsoString = utcTimestamp.replace(" ", "T") + "Z";
  const date = new Date(newIsoString);
  return date.toLocaleString(undefined, { timeZoneName: "short" });
}
